import { Routes } from '@angular/router'
import { AppComponent } from './app/khb.component';
import { RegistrationComponent } from './app/registration/registration.component';
import { LoginComponent } from './app/registration/login/login.component';
import { SignupComponent } from './app/registration/signup/signup.component';
import { UltilitiesComponent } from './app/ultilities/ultilities.component';
import { RolesComponent } from './app/ultilities/roles/roles.component';
import { RolesGridComponent } from './app/ultilities/roles/roles-grid/roles-grid.component';
import { RolesFormComponent } from './app/ultilities/roles/roles-form/roles-form.component';
import { UserComponent } from './app/ultilities/user/user.component';
import { UserGridComponent } from './app/ultilities/user/user-grid/user-grid.component';
import { UserFormComponent } from './app/ultilities/user/user-form/user-form.component';
import { ClaimsComponent } from './app/ultilities/claims/claims/claims.component';
import { ClaimGridComponent } from './app/ultilities/claims/claims/claim-grid/claim-grid.component';
import { ClaimFormComponent } from './app/ultilities/claims/claims/claim-form/claim-form.component';
import { SettingComponent } from './app/ultilities/setting/setting.component';
import { HomepageComponent } from './app/homepage/homepage.component';
import { AuthGuard } from './app/auth/auth.guard';
import { ChangePasswordComponent } from './app/ultilities/change-password/change-password.component';
import { PetitionComponent } from './app/petition/petition.component';
import { PetitionGridComponent } from './app/petition/petition-grid/petition-grid.component';
import { PetitionFormComponent } from './app/petition/petition-form/petition-form.component';
import { PetitionApprovalComponent } from './app/petition/petition-approval/petition-approval.component';
import { MastersComponent } from './app/masters/masters.component';
import { DistrictGridComponent } from './app/masters/district/district-grid/district-grid.component';
import { DistrictFormComponent } from './app/masters/district/district-form/district-form.component';
import { FinanceComponent } from './app/finance/finance.component';
import { BudgetFormComponent } from './app/finance/budget/budget-form/budget-form.component';
import { BudgetGridComponent } from './app/finance/budget/budget-grid/budget-grid.component';
import { ExpenditureGridComponent } from './app/finance/expenditure/expenditure-grid/expenditure-grid.component';
import { ExpenditureFormComponent } from './app/finance/expenditure/expenditure-form/expenditure-form.component';
import { VehicleGridComponent } from './app/ultilities/vehicle/vehicle-grid/vehicle-grid.component';
import { VehicleFormComponent } from './app/ultilities/vehicle/vehicle-form/vehicle-form.component';
import { CasteVerificationComponent } from './app/caste-verification/caste-verification.component';
import { CasteVerificationGridComponent } from './app/caste-verification/caste-verification-grid/caste-verification-grid.component';
import { CasteVerificationFormComponent } from './app/caste-verification/caste-verification-form/caste-verification-form.component';
import { PetitionApprovalGridComponent } from './app/petition/petition-approval-grid/petition-approval-grid.component';
import { CorrespondanceTrackingComponent } from './app/correspondance-tracking/correspondance-tracking.component';
import { CtGridComponent } from './app/correspondance-tracking/ct-grid/ct-grid.component';
import { CtFormComponent } from './app/correspondance-tracking/ct-form/ct-form.component';
import { TalukGridComponent } from './app/masters/taluk/taluk-grid/taluk-grid.component';
import { TalukFormComponent } from './app/masters/taluk/taluk-form/taluk-form.component';
import { OfficeGridComponent } from './app/masters/office/office-grid/office-grid.component';
import { OfficeFormComponent } from './app/masters/office/office-form/office-form.component';

// var data = localStorage.getItem("accessToken");
// var defaultPage;
// if(data) defaultPage = "/home"; else defaultPage = "/login";
//canActivate : [AuthGuard],
export const appRoutes: Routes = [
    {
        path: 'home',component: HomepageComponent, canActivate : [AuthGuard],
        children: [
            {
                path: 'password',component: UltilitiesComponent,
                children: [{path: '', component: ChangePasswordComponent}]
            },  

            {
                path: 'password/:userId',component: UltilitiesComponent,
                children: [{path: '', component: ChangePasswordComponent}]
            },  

            {
                path: 'rolesgrid',component: UltilitiesComponent,
                children: [{path: '', component: RolesGridComponent}]
            },  
                
            {
                path: 'rolesform',component: UltilitiesComponent,
                children: [{path: '', component: RolesFormComponent}]
            },
        
            {
                path: 'rolesform/:roleId/:mode',component: UltilitiesComponent,
                children: [{path: '', component: RolesFormComponent}]
            },            
                                          
            {
                path: 'userlist',component: UltilitiesComponent,
                children: [{path: '', component: UserGridComponent}]
            }, 
                    
            {
                path: 'userform',component: UltilitiesComponent,
                children: [{path: '', component: UserFormComponent}]
            },   

            {
                path: 'userform/:Id/:mode',component: UltilitiesComponent,
                children: [{path: '', component: UserFormComponent}]
            },    
                        
            {
                path: 'claimslist',component: UltilitiesComponent,
                children: [{path: '', component: ClaimGridComponent}]
            },  
        
            {
                path: 'claimform',component: UltilitiesComponent,
                children: [{path: '', component: ClaimFormComponent}]
            },     
                           
            {
                path: 'claimform/:roleId/:roleName/:officeName',component: UltilitiesComponent,
                children: [{path: '', component: ClaimFormComponent}]
            },
            
            {
                path: 'claimform/:roleId/:roleName/:officeName',component: UltilitiesComponent,
                children: [{path: '', component: ClaimFormComponent}]
            },   
            {
                path: 'petition',component: PetitionComponent,
                children: [{path: '', component: PetitionGridComponent}]
            },      
            {
                path: 'new-petition',component: PetitionComponent,
                children: [{path: '', component: PetitionFormComponent}]
            }, 
            {
                path: 'petitionapproval',component: PetitionComponent,
                children: [{path: '', component: PetitionApprovalGridComponent}]
            },
            {
                path: 'petitionapprovalform',component: PetitionComponent,
                children: [{path: '', component: PetitionApprovalComponent}]
            },
            {
                path: 'district',component: MastersComponent,
                children: [{path: '', component: DistrictGridComponent}]
            },    
            {
                path: 'districtform',component: MastersComponent,
                children: [{path: '', component: DistrictFormComponent}]
            },
            {
                path: 'budget',component: FinanceComponent,
                children: [{path: '', component: BudgetGridComponent}]
            },
            {
                path: 'budgetform',component: FinanceComponent,
                children: [{path: '', component: BudgetFormComponent}]
            },
            {
                path: 'expenditure',component: FinanceComponent,
                children: [{path: '', component: ExpenditureGridComponent}]
            },
            {
                path: 'expenditureform',component: FinanceComponent,
                children: [{path: '', component: ExpenditureFormComponent}]
            },
            {
                path: 'vehicle',component: UltilitiesComponent,
                children: [{path: '', component: VehicleGridComponent}]
            },
            {
                path: 'vehicleform',component: UltilitiesComponent,
                children: [{path: '', component: VehicleFormComponent}]
            },
            {
                path: 'casteverification',component: CasteVerificationComponent,
                children: [{path: '', component: CasteVerificationGridComponent}]
            },
            {
                path: 'casteverificationform',component: CasteVerificationComponent,
                children: [{path: '', component: CasteVerificationFormComponent}]
            },
            {
                path: 'correspondancetracking',component: CorrespondanceTrackingComponent,
                children: [{path: '', component: CtGridComponent}]
            },
            {
                path: 'correspondancetracking-form',component: CorrespondanceTrackingComponent,
                children: [{path: '', component: CtFormComponent}]
            },
            {
                path: 'taluk',component: MastersComponent,
                children: [{path: '', component: TalukGridComponent}]
            },
            {
                path: 'talukform',component: MastersComponent,
                children: [{path: '', component: TalukFormComponent}]
            },
            {
                path: 'office',component: MastersComponent,
                children: [{path: '', component: OfficeGridComponent}]
            },
            {
                path: 'officeform',component: MastersComponent,
                children: [{path: '', component: OfficeFormComponent}]
            },
            // {
            //     path: 'regiongrid',component: MastersComponent,
            //     children: [{path: '', component: }]
            // },
            // {
            //     path: 'regionform',component: MastersComponent,
            //     children: [{path: '', component: PetitionApprovalComponent}]
            // },        
            
        ]
    },
    {
        path: 'login', component: RegistrationComponent,
        children: [{path: '', component: LoginComponent}]
    },
            
    {
        path: 'signup', component: RegistrationComponent,
        children: [{path: '', component: SignupComponent}]  
    },

    // {
    //     path: 'forgot-password', component: RegistrationComponent,
    //     children: [{path: '', component: ForgotPasswordComponent}]  
    // },
    
    
    { path : '', redirectTo:'/login', pathMatch : 'full'}
];


// WEBPACK FOOTER //
// ./src/route.ts